import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { ROUTES } from 'src/router/routes';
import App from 'src/App';
import HomePage from 'src/pages/HomePage/HomePage';
import { Spinner } from 'src/components/Spinner/Spinner';

const NotFoundPage = lazy(() => import('src/pages/NotFoundPage/NotFoundPage'));
const ErrorPage = lazy(() => import('src/pages/ErrorPage/ErrorPage'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: (
      <Suspense fallback={<Spinner />}>
        <ErrorPage />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Spinner />}>
            <HomePage />
          </Suspense>
        ),
      },
      {
        path: ROUTES.NOT_FOUND,
        element: (
          <Suspense fallback={<Spinner />}>
            <NotFoundPage />
          </Suspense>
        ),
      },
    ],
  },
]);
